import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalIssueNavigatorBrowseIssueRedirectRoute } from '@jira/router-routes__issue-navigator-routes/src/globalIssueNavigatorBrowseIssueRedirectRoute.tsx';
import { GlobalIssueNavigatorSkeleton } from '@jira/platform__skeletons/src/ui/issue-navigator/components/global-app.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@jira/platform__observability-capabilities/src/constants.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getCommonGlobalNavigation } from './common/getCommonGlobalNavigation.tsx';
import { getCommonGlobalResources } from './common/getCommonGlobalResources.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import GinBrowseIssuesRedirect from './ui/gin-browse-issue-redirect/index.tsx';
import { LazyGlobalIssueNavigator } from './ui/index.tsx';

export const globalIssueNavigatorBrowseIssueRedirectRouteEntry: Route = createEntry(
	globalIssueNavigatorBrowseIssueRedirectRoute,

	() => ({
		group: 'issue-navigator',
		apdexIgnoreParams: ['issueKey'],

		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},

		// eslint-disable-next-line no-restricted-syntax
		component: GinBrowseIssuesRedirect,
		skeleton: GlobalIssueNavigatorSkeleton,
		forPaint: [LazyAtlassianNavigation, LazyGlobalIssueNavigator],
		ufoName: 'global-issue-navigator-jfe',
		navigation: getCommonGlobalNavigation(),
		resources: [...getCommonGlobalResources()],
		layout: globalLayout,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
